(function() {
    'use strict';

    /*global angular*/
    angular.module('vhols')
        .controller('collapseSectionController', function () { });
})();
